import { useEffect, useState } from "react";

let cached = null;
const listeners = new Set();

async function fetchLogo() {
  try {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    const r = await fetch(`${base}/api/settings/public`);
    if (!r.ok) return;
    const d = await r.json();
    cached = d.logo_url ? `${base}${d.logo_url}` : "/nayan-logo.png";
    listeners.forEach((fn) => fn(cached));
  } catch {
    cached = cached || "/nayan-logo.png";
  }
}

export function useLogo() {
  const [logo, setLogo] = useState(cached || "/nayan-logo.png");
  useEffect(() => {
    const fn = (v) => setLogo(v);
    listeners.add(fn);
    fetchLogo();
    const onChange = () => { cached = null; fetchLogo(); };
    window.addEventListener("logoChanged", onChange);
    return () => { listeners.delete(fn); window.removeEventListener("logoChanged", onChange); };
  }, []);
  return logo;
}
